function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { TosCheckbox } from 'swag-client-common/components/partials/tos-checkbox';
import { PaymentInformationForm } from '../payment-information-form';
import { PaymentDetailsTitleLine } from '../payment-details-title-line';
import FormCheckbox from '../form-checkbox';
import { CreditsWidget as MakeApiDefaultPaymentMethodWidget } from '../../make-api-default-payment-method-widget';
import responsiveClasses from './payment-information.scss';
import fixedClasses from './payment-information-fixed.scss';
export class PaymentInformation extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handlePayByCreditsClick", () => {
      const {
        onPayByCredits
      } = this.props;
      if (onPayByCredits) {
        onPayByCredits();
      }
    });
  }
  render() {
    const {
      isSaveAvailable,
      isTOSCheckboxShown,
      isSelectCardShown,
      disableWholeForm,
      isAutoPayCheckbox,
      isAutoPayCheckboxDisable,
      isCreditsAvailable,
      buyCreditsFlow,
      popupType,
      autopayLabel,
      isFixedStyles = false,
      onCardSelect
    } = this.props;
    const classes = isFixedStyles ? fixedClasses : responsiveClasses;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.wrapper
    }, /*#__PURE__*/React.createElement(PaymentDetailsTitleLine, {
      isFixedStyles: isFixedStyles,
      title: "Payment Information"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.specialButtonContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.specialButton
    }, isSelectCardShown && /*#__PURE__*/React.createElement("span", {
      onClick: onCardSelect,
      "data-button": "DifferentCard",
      className: classnames(classes.useDifferentCard)
    }, "Use a saved card on file")), isCreditsAvailable && /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.useDifferentCard, classes.payWithCredits),
      onClick: this.handlePayByCreditsClick,
      "data-button": "PayWithCredits"
    }, "Pay with credits"))), /*#__PURE__*/React.createElement(PaymentInformationForm, {
      popupType: popupType,
      disableWholeForm: disableWholeForm,
      isFixedStyles: isFixedStyles
    }), isTOSCheckboxShown && /*#__PURE__*/React.createElement(TosCheckbox, {
      tosCheckboxWrapperClassName: classes.checkbox,
      isFixedStyling: false,
      buttonName: "Pay"
    }), isSaveAvailable && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormCheckbox, {
      className: classes.checkbox,
      label: "Save the payment details for future use.",
      name: "savePaymentDetails",
      dataInput: "SavePaymentDetails"
    }), isAutoPayCheckbox && /*#__PURE__*/React.createElement(FormCheckbox, {
      className: classnames(classes.checkbox, {
        [classes.disabled]: isAutoPayCheckboxDisable
      }),
      disabled: isAutoPayCheckboxDisable,
      label: autopayLabel,
      name: "saveAutoPay",
      dataInput: "SaveAutoPay"
    }), buyCreditsFlow && /*#__PURE__*/React.createElement(MakeApiDefaultPaymentMethodWidget, {
      className: classes.checkbox
    })));
  }
}